// extracted by mini-css-extract-plugin
export default {"typewriter":"Typewriter_typewriter__ypMms","cursor":"Typewriter_cursor__CrMB-","blink":"Typewriter_blink__dsEF6"};